/**
 * Browser download helpers shared across every "Download as ZIP" surface
 * (Vault, Mobility, TelePortal — citizen + business). Keeping the anchor-click
 * dance in one place means the bulk-download UX is identical everywhere and
 * there is no copy-pasted DOM glue to drift.
 */

/**
 * Trigger a browser "Save as" for an in-memory {@link Blob} (e.g. a ZIP/PDF
 * built by an API call returning `responseType: 'blob'`). Creates a transient
 * object URL, clicks a hidden anchor, then revokes the URL.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the click has a chance to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
